import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';

import { AuthenticationService } from './authentication.service';
import { ActiveProductsService } from 'src/app/services/active-products.service';
import { Ap1Service } from '../apps/ap1/ap1.service';
import { VehicleDataService } from '../apps/ap1/step1/vehicle/vehicle-data.service';


@Injectable({
  providedIn: 'root'
})
export class FormGuardGuardProduts {
  private actPrServ = inject(ActiveProductsService);
  private authServ = inject(AuthenticationService);
  private router = inject(Router);
  private ap1Serv = inject(Ap1Service);
  private dataServ = inject(VehicleDataService)


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Promise<boolean>(async (resolve) => {
      const nm = state.url.substring(1).replace(/[/?][^/]*/, '');
      const activeProducts = await this.actPrServ.getActiveProducts();
      if (!activeProducts.includes(nm.toUpperCase())) {
        const userType = this.authServ.currentUserValue.userType;
        this.router.navigate([ userType === 2 ? '/uran-copy-agent' : '/notfound']);
        resolve(false); return false;
      }
      if (nm.toUpperCase() === 'AP1') {
        this.ap1Serv.emptyMe();
        this.dataServ.emptyMe();
      }
      resolve(true); return true;
    });
  }

}
